import { Mask } from './Mask';
import { Player } from '../game/Player';

export class HadesMask extends Mask {
  constructor(player: Player) {
    super(
      'Mask of Hades',
      'Become invisible and phase through barriers',
      0x9c27b0, // Purple
      player
    );
    
    this.maxAbilityDuration = 5; // 5 seconds of invisibility/phasing
    this.cooldownTime = 10; // 10 second cooldown
  }
  
  protected onActivate(): void {
    // Passive phase through is always active when wearing
    this.player.canPhaseThrough = true;
  }
  
  protected onDeactivate(): void {
    this.player.canPhaseThrough = false;
    this.player.isInvisible = false;
  }
  
  protected onUpdate(_deltaTime: number): void {
    // Could add shadow particle effects
  }
  
  protected onAbilityStart(): void {
    // Become invisible to guardians
    this.player.isInvisible = true;
  }
  
  protected onAbilityEnd(): void {
    this.player.isInvisible = false;
  }
}
